import './Settings.scss'
import { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import Flex from '../../../components/utils/Flex'
import Container from '../../../components/utils/Container'
import UserbarUser from '../../../components/UserbarUser'

import ProfileThumb from '../../../assets/images/profile-thumb.png'
import ProfileCover from '../../../assets/images/profile-cover.png'

const Settings = () => {

	const history = useHistory()
	const hfInputCover = useRef(null)
	const hfInputProfile = useRef(null)

	const [user, setUser] = useState({
		bio: '',
		cover: null,
		avatar: null,
		location: '',
		username: 'johndoe',
	})

	const onInputFile = (event, key) => {
		setUser({ ...user, [key]: URL.createObjectURL(event.target.files[0]) })
	}

	return (
		<div className="usettings">
			<Container>
				<UserbarUser className="py-2" />
			</Container>
			<div className="bg-secondary pt-3">
				<Flex on="lg">
					<aside
						className="usettings__sidebar bg-primary flex-none mb-3 lg:mb-0 p-3 lg:p-9"
					>
						<ul className="flex lg:block">
							<li
								className="usettings__tab relative bg-cyan-accent py-2 px-2 lg:py-5 lg:px-4 rounded lg:rounded-xl font-bold text-base lg:text-xl cursor-pointer lg:mb-4 mr-3 lg:mr-0"
							>
								Profile
							</li>
							<li
								className="usettings__tab relative py-2 px-2 lg:py-5 lg:px-4 rounded lg:rounded-xl font-bold text-base lg:text-xl cursor-pointer"
							>
								Payments and Earning
							</li>
						</ul>
					</aside>
					<div className="bg-primary p-3 lg:p-12 lg:ml-3 lg:rounded-tl-xl flex-1">
						<h4 className="font-bold text-xl lg:text-2xl 2xl:text-3xl">
							Edit Profile
						</h4>
						<p className="text-base text-secondary lg:text-xl lg:mt-8">
							Update your cover and avatar image
						</p>
						<hr className='border-3b border-2 w-72 mt-4' />
						<div className="relative mt-2.5">
							<img
								alt="Profile Cover"
								src={user.cover || ProfileCover}
								className="usettings__cover-img rounded-xl w-full object-cover object-center"
							/>
							<button
								onClick={() => { hfInputCover.current.click() }}
								className="absolute top-2 right-2 z-10 bg-gray-900 bg-opacity-50 flex items-center justify-center p-1 rounded"
							>
								<span className="material-icons text-xl lg:text-2xl"
								>camera_alt</span
								>
							</button>
							<div
								className="profile__content absolute inset-0 flex flex-col justify-end items-center"
							>
								<div
									className="w-28 h-28 lg:w-60 lg:h-60 rounded-xl relative overflow-hidden -mb-8 lg:-mb-16"
								>
									<img
										className="w-full h-full object-cover object-center"
										src={(user && user.avatar) || ProfileThumb}
										alt="Profile Thumbnail"
									/>
									<button
										onClick={() => { hfInputProfile.current.click() }}
										className="absolute bottom-1 right-2 bg-gray-900 bg-opacity-50 flex items-center justify-center p-1 rounded"
									>
										<span className="material-icons text-xl lg:text-2xl"
										>camera_alt</span
										>
									</button>
								</div>
							</div>
						</div>
						<div className="py-10"></div>
						<h4 className="text-xl lg:text-2xl 2xl:text-3xl">
							Edit Username
						</h4>
						<label htmlFor="username" className="sr-only"></label>
						<input
							type="text"
							id="username"
							name="username"
							value={user.username}
							onChange={e => setUser({ ...user, username: e.target.value })}
							className="w-full border-b-2 text-base lg:text-xl bg-primary border-secondary2 py-2"
						/>
						<p className="text-base mt-1">
							This will be displayed as
							<button
								className="text-yellow-500"
								onClick={() => history.push(`/${user.username}`)}
							>
								https://phoria.tv/{user.username}
							</button>
						</p>
						<div className="py-5"></div>
						<h4 className="text-xl lg:text-2xl 2xl:text-3xl">
							Edit About Me
						</h4>
						<label htmlFor="bio" className="sr-only"></label>
						<textarea
							name="bio"
							id="bio"
							value={user.bio}
							onChange={e => setUser({ ...user, bio: e.target.value })}
							placeholder="Write your bio here"
							className="w-full border-b-2 text-base lg:text-xl bg-primary border-secondary2 py-2"
						/>
						<p className="text-base mt-1">
							This will be displayed on your profile.
						</p>
						<div className="py-5"></div>
						<h4 className="text-xl lg:text-2xl 2xl:text-3xl">
							Location
						</h4>
						<label htmlFor="location" className="sr-only"></label>
						<input
							type="text"
							id="location"
							name="location"
							value={user.location}
							onChange={e => setUser({ ...user, location: e.target.value })}
							placeholder="Where are you?"
							className="w-full border-b-2 text-base lg:text-xl bg-primary border-secondary2 py-2"
						/>
						<p className="text-base mt-1">
							Let your subscribers know where you're based.
						</p>
					</div >
				</Flex >
			</div >
			<input
				type="file"
				ref={hfInputProfile}
				className='hidden'
				accept="image/x-png,image/gif,image/jpeg"
				onInput={ev => onInputFile(ev, 'avatar')}
			/>
			<input
				type="file"
				ref={hfInputCover}
				className='hidden'
				accept="image/x-png,image/gif,image/jpeg"
				onInput={ev => onInputFile(ev, 'cover')}
			/>
		</div >
	)
}

export default Settings